import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'graduate_disciplines_modules',
  route: 'graduate/disciplines_modules',
  label: 'Módulos e Disciplinas',
  actions: ['list', 'show', 'create', 'edit', 'delete'],
  onlyPermission: true,
  parentName: 'course_creation'
};

export default generateResources(resource);
